<template>
  <div class="field">
    <label class="label" v-bind:class="{'has-text-danger': hasError}">
      <span class="labelspan" v-html="name"></span>
      <font-awesome-icon icon="info-circle" v-if="help" :title="help" style="cursor: help;" />
    </label>
    <p class="control">
      <input
        class="input"
        type="text"
        v-bind:value="value"
        v-on:input="onInput"
        v-bind:class="{'is-danger': hasError}"
        v-bind:id="id"
      />
    </p>
    <p class="help">
      <!-- Using v-html directive so that units can use html tags for superscript etc. -->
      <span v-if="units" v-html="units"></span>
      <span v-else class="has-text-white">1</span>
      &nbsp;
      <span class="has-text-danger" v-if="hasError">
        <font-awesome-icon icon="exclamation-triangle" />
        {{errorMessage}}
      </span>
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hasError: false,
    };
  },
  computed: {
    errorMessage() {
      if (Number.isNaN(this.value)) {
        return 'Invalid value. Must be a number.';
      }

      if (this.vpositive) {
        return 'Invalid value. Must be positive.';
      }

      return `Invalid value. Must be in range of ${this.vmin} to ${this.vmax}.`;
    },
  },
  methods: {
    onInput(event) {
      const newValue = event.target.value;
      this.$emit('input', newValue);
    },
    validate() {
      let hasError = false;
      if (
        this.value !== ''
        && (Number.isNaN(Number(this.value))
          || (this.vmin !== null && this.value < this.vmin)
          || (this.vmax !== null && this.value > this.vmax)
          || (this.vpositive && this.value <= 0))
      ) {
        hasError = true;
      }
      this.hasError = hasError;
      this.$emit('fieldEvent'); // can be picked up by parent component
    },
  },
  props: {
    name: String,
    units: String,
    value: String,
    vmin: { type: Number, default: null },
    vmax: { type: Number, default: null },
    vpositive: Boolean,
    help: String,
    id: String,
  },
  watch: {
    value() {
      this.validate();
    },
    vmin() {
      this.validate();
    },
    vmax() {
      this.validate();
    },
  },
};
</script>

<style scoped>
.labelspan {
  margin-right: 0.25em;
}
</style>
